import PropTypes from 'prop-types';
import { Table as ReactStrapTable } from 'reactstrap';
import React from 'react';
import { TableVirtuoso } from 'react-virtuoso';
import './DataTable.scss';

const Table = ({ children, ...props }) => (
  <ReactStrapTable
    bordered
    className="position-relative fixed-header mb-0"
    {...props}
  >
    {children}
  </ReactStrapTable>
);

const TableHead = ({ children, className, ...props }) => (
  <thead
    className={className}
    {...props}
  >
    {children}
  </thead>
);

const Headers = ({ columns }) => (
  <tr>
    {columns.map(({ headerName, headerClassName }) => (
      <th key={headerName} className={headerClassName}>
        {headerName}
      </th>
    ))}
  </tr>
);

const RowItem = ({ data, headers }) => headers.map(({ accessor, Cell, bodyClassName }) => (
  <td className={bodyClassName}>
    {accessor ? data[accessor] : Cell(data)}
  </td>
));

const DataTable = ({ dataItems, headers, headerClassName = '', rowClassName = '' }) => (
  <TableVirtuoso
    style={{ height: dataItems.length > 3 ? 800 : 400 }}
    data={dataItems}
    components={{
      Table,
      TableHead: (props) => <TableHead {...props} className={headerClassName} />,
      TableRow: ({ children, ...props }) => (
        <tr className={`table-row ${rowClassName}`} {...props}>
          {children}
        </tr>
      ),

    }}
    fixedHeaderContent={() => <Headers columns={headers} />}
    itemContent={(_, data) => <RowItem data={data} headers={headers} />}
  />
);

DataTable.propTypes = {
  dataItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  headers: PropTypes.arrayOf({
    headerName: PropTypes.string.isRequired,
    accessor: PropTypes.string,
    headerClassName: PropTypes.string,
    bodyClassName: PropTypes.string,
    Cell: PropTypes.func,
  }).isRequired,
  headerClassName: PropTypes.string,
  rowClassName: PropTypes.string,
};

DataTable.defaultProps = {
  headerClassName: '',
  rowClassName: '',
};

export default DataTable;
